/**
 * User: Shad
 * Date: 8/13/13
 */
"use strict";

var ShipmentQuote = require('bunsen/models/logistics/ShipmentQuote.js');

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};
var TransactionShipmentQuote = module.exports = bunsen.TransactionShipmentQuote = ShipmentQuote.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var endpoints = require('dibs-endpoints');
var SoaModel = require('bunsen/models/SoaModel');
var AdjustmentList = require('bunsen/models/ecomm/AdjustmentList');
var Notes = require('bunsen/collections/Notes');
var Note = require('bunsen/models/Note');
var Party = require('bunsen/models/Party');
var Anchor = require('bunsen/models/Anchor');
var transitionMixin = require('bunsen/models/mixins/ecomm/transitionMixin');
var assert = require('bunsen/helpers/assert');

_.extend(TransactionShipmentQuote, {
    STATUS_NEW: 'NEW',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_DEALER_REJECTED: 'DEALER_REJECTED',
    STATUS_DEALER_ACCEPTED: 'DEALER_ACCEPTED',
    STATUS_BUYER_ACCEPTED: 'BUYER_ACCEPTED',
    STATUS_PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
    STATUS_ACCEPTED: 'ACCEPTED',
    STATUS_CANCELED: 'CANCELED'
});

_.extend(TransactionShipmentQuote.prototype, {
    idAttribute: "id",
    anchorType: Anchor.TYPE_SHIPMENT_QUOTE,

    defaults: _.extend({}, ShipmentQuote.prototype.defaults, {
        notes: [],
        complimentaryShipping: 'N'
    }),

    initialize: function () {

        TransactionShipmentQuote.__super__.initialize.apply(this, arguments);
        this.url = function () {
            return endpoints.ecomShipmentQuote(this.id);
        };
    },
    relations: function () {
        // Get the parent's relations and add ecom specific relations.
        var relations = _.result(ShipmentQuote.prototype, 'relations').slice(0);
        relations.push(SoaModel.createRelations([
            {
                type : Backbone.One,
                key : 'adjustments',
                relatedModel : AdjustmentList
            },
            {
                type: Backbone.Many,
                key: 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type: Backbone.One,
                key: 'anchor',
                relatedModel: SoaModel
            }
        ]));
        return _.flatten(relations);
    },
    getTransactionId: function () {
        if (this.get('anchor.sourceType') === 'TRANSACTION') {
            return this.get('anchor.sourceId');
        }
    },

    wasAcceptedByDealer: function () {
        var statuses = ['DEALER_ACCEPTED', 'PAYMENT_REQUIRED', 'BUYER_ACCEPTED'];
        return _.contains(statuses, this.get('status'));
    },
    wasAcceptedByBuyer: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_BUYER_ACCEPTED;
    },
    wasAcceptedForAccounting: function () {
        return this.isAccountingQuote() && this.get('status') === TransactionShipmentQuote.STATUS_ACCEPTED;
    },
    isQuoteRequest: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_NEW;
    },
    isQuoteSubmitted: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_SUBMITTED;
    },
    isActive: function () {
        var statuses = [TransactionShipmentQuote.STATUS_CANCELED, TransactionShipmentQuote.STATUS_DEALER_REJECTED];
        return !_.contains(statuses, this.get('status'));
    },
    isActiveAccountingQuote: function () {
        return this.isAccountingQuote() && this.get('status') !== TransactionShipmentQuote.STATUS_DEALER_REJECTED && this.get('status') !== TransactionShipmentQuote.STATUS_CANCELED;
    },
    isRejectedAccountingQuote: function () {
        return this.isAccountingQuote() && this.get('status') === TransactionShipmentQuote.STATUS_DEALER_REJECTED;
    },
    getSellerId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.collection.parents[0].get('seller').id;
    },
    isComplimentary: function () {
        return this.get('complimentaryShipping') === 'Y';
    },
    isFreeToBuyer: function () {
        return !this.hasCostGreaterThanZero() || this.isComplimentary();

    },
    getTaxAmount: function (currency) {
        var adjustments = this.get('adjustments');
        if (adjustments) {
            return adjustments.getShippingTaxTotal(currency);
        }
        return 0;
    },
    newNote: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            anchors: [
                {
                    sourceId : this.getTransactionId(),
                    sourceType : Anchor.TYPE_TRANSACTION
                },
                {
                    sourceId: this.id,
                    sourceType: Anchor.TYPE_SHIPMENT_QUOTE
                },
                {
                    sourceId: this.getSellerId(),
                    sourceType: Anchor.TYPE_SELLER
                }
            ]
        });
        return this.get('notes').newNote(options);
    },
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    newBuyerSellerNote: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            type: Note.TYPE_BUYER_SELLER
        });
        return this.newNote(options);
    },
    getLastNote: function () {
        var notes = this.get('notes');
        return notes ? notes.last() : null;
    },
    setComplimentaryIfFree: function () {
        if (!this.hasCostGreaterThanZero()) {
            this.set('complimentaryShipping', 'Y');
        }
    },
    /**
     * Accept/Counter offer while creating shipment quote with note
     * @param {Offer} offer
     * @param {Offer} counterOffer
     * @param {object} [passedOptions]
     */
    dealerSubmitWithOffer: function (offer, counterOffer, passedOptions) {
        this.setComplimentaryIfFree();
        return this.dealerTransitionWithOfferNote(null, offer, counterOffer, passedOptions);
    },
    /**
     * Accept/Counter offer while accepting shipment quote with note
     * @param {Offer} offer
     * @param {Offer} counterOffer
     * @param {object} [passedOptions]
     * @returns {$.Deferred.promise}
     */
    dealerAcceptWithOffer: function (offer, counterOffer, passedOptions) {
        var options = _.extend({
            transitionFunction: 'updateAndTransition'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.dealerTransitionWithOfferNote(
            TransactionShipmentQuote.STATUS_DEALER_ACCEPTED,
            offer,
            counterOffer,
            options
        );
    },
    updateAccountingQuote: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.save(null, { clump: clump });
    },
    /**
     * @param {Clump} [clump]
     * @returns {$.Deferred.promise}
     */
    acceptAccountingQuote: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.updateAndTransition(TransactionShipmentQuote.STATUS_ACCEPTED, { clump: clump });
    },

    /**
     * @param {Clump} [clump]
     * @returns {$.Deferred.promise}
     */
    rejectAccountingQuoteForDealer: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.transition(TransactionShipmentQuote.STATUS_DEALER_REJECTED, { clump: clump });
    },

    /**
     * Save this quote model instance as a 'submitted' 1stdibs quote
     * to the logistics service, which will then be displayed to the
     * dealer for approval.
     * @param {object} [passedOptions]
     * @returns {$.Deferred.promise}
     */
    provide1stdibsQuote: function (passedOptions) {
        var options = _.extend({
            noteRole: Party.ROLE_INTERNAL,
            noteType: Note.TYPE_SELLER_ADMIN,
            transitionFunction: 'updateAndTransition'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.transitionWithNote(TransactionShipmentQuote.STATUS_SUBMITTED, options);
    },
    saveModifiedQuote: function (passedOptions) {
        var options = _.extend({
            noteRole: Party.ROLE_INTERNAL,
            noteType: Note.TYPE_SELLER_ADMIN,
            transitionFunction: 'update'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.transitionWithNote(null, options);
    },

    /**
     * Saves the shipmentQuote with notes on them, have to use temporary SoaModel
     * as currently notes are omitted from the save on this model
     * @returns {*|$.Deferred.promise}
     */
    saveWithNotes: function () {
        var soaModel = new SoaModel(this.toJSON());
        soaModel.url = endpoints.ecomShipmentQuote(this.id);
        return soaModel.save();
    }

}, transitionMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/TransactionShipmentQuote.js
// module id = 36
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56